import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import groupService from "../../../services/groupService";
import IFolderFormProps from "../IFolderFormProps";
import IGroup from "../../../models/IGroup";
import Status from "../../../enums/Status";
import { Col, Row } from "react-grid-system";
import AudienceField from "../../../components/formFields/audience/select/AudienceField";
import AudienceList from "../../../components/formFields/audience/selected/AudienceList";
import Placeholder from "../../../components/formFields/audience/Placeholder";
import Error from "../../../components/formFields/audience/Error";

export default function AudienceTab(props: IFolderFormProps) {
    const { t } = useTranslation();

    const [groups, setGroups] = useState<IGroup[]>([]);
    const [status, setStatus] = useState<Status>(Status.LOADING);

    useEffect(() => {
        loadGroups(setGroups, setStatus);
    }, []);

    const handleRemove = (id: string) => {
        const newGroups = props.data.audience.filter((group) => group.id !== id);
        props.onChange("audience", newGroups);
    }

    return (
        <Row>
            <Col>
                {
                    status === Status.LOADING &&
                    <Placeholder />
                }
                {
                    status === Status.LOAD_ERROR &&
                    <Error />
                }
                {
                    status === Status.LOAD_SUCCESS &&
                    <Row>
                        <Col>
                            <AudienceField
                                groups={groups}
                                placeholder={t("folders.form.fields.audienceTargeting.placeholder")}
                                selectedGroups={props.data.audience}
                                onSelect={(groups) => props.onChange("audience", groups)}
                                />
                            <AudienceList
                                selectedText={t("folders.form.fields.audienceTargeting.selected")}
                                noGroupsSelectedText={t("folders.form.fields.audienceTargeting.noneSelected")}
                                selectedGroups={props.data.audience}
                                onRemove={handleRemove} />
                        </Col>
                    </Row>
                }
            </Col>
        </Row>
    );
}

async function loadGroups(
    setGroups: (groups: IGroup[]) => void,
    setStatus: (status: Status) => void
) {
    try {
        const groups = await groupService.getGroups();
        setGroups(groups);
        setStatus(Status.LOAD_SUCCESS);
    } catch {
        setStatus(Status.LOAD_ERROR);
    }
}